export const MainBackground = require('./mainbg.jpg')
export const GrowingBackground = require('./growingbg.jpg')
export const InventoryBackground = require('./inventorybg.jpg')
export const WarehousingBackground = require('./spaceallocationbg.jpg')
export const PatchingBackground = require('./patchingbg.jpg')
export const LogisticsBackground = require('./logistics.jpg')
export const InvoicingBackground = require('./invoicingbg.jpg')